
import { ApiModule } from '@api/src/ApiModule'

// An Api module for UI components
export class Logger extends ApiModule {

    constructor(props) {
        super(props)

        this.saveErrorShown = false

        // Add a response interceptor to Axios
        this.enableErrorModals = this.getGlobal('tenant.enable_error_modals', false)
        this.isDev = this.getGlobal('ENV', false)

        if (this.enableErrorModals === true) {
            this.allowAllErrors = false

            this.log('Axios error modals enabled')

            // Enable axios error handler
            // window.axios.interceptors.response.use(this.axiosSuccess.bind(this), this.axiosError.bind(this))

            // Test axios errors
            // if (this.isDev) this.testAxiosError()
        }
    }


    // Datadog
    datadogError(name, data) {
        window.DD_LOGS && DD_LOGS.logger.log('Button clicked', {
            name: 'buttonName'
        })
    }

    // Axios
    testAxiosError() {
        this.allowAllErrors = true
        // axios.get(`/dummy/error/endpoint`)
        axios.get(`/api/test-status/402`)
    }

    axiosSuccess(response) {
        // Any status code that lie within the range of 2xx cause this function to trigger
        // Do something with response data
        return response
    }

    saveError(force = false) {

        if (!force && this.enableErrorModals === false) return
        if (!force && this.saveErrorShown === true) return

        // Mark as shown once per load
        this.saveErrorShown = true

        // const title = 'Check Your Data Fields'
        const title = 'Unable to Save Application'

        const $b = (txt) => `<span style="font-weight: bold;">${txt}</span>`

        // Do something with response error
        const html = `
        <div class="mb-2" style="text-align: center; padding: 15px; line-height: 2;">
            <div style="font-weight: bold; font-size: 18px;" class="mb-2">${title}</div>

            <div class="mb-0 mt-0" style="font-size: 12px; text-align: left;">
                <div class="mb-3">
                  You are about to lose data because not all required fields are completed correctly. Please check the application and ensure that:
                </div>
                <ul>
                    <li>Applicant’s ${$b('full name')} and ${$b('title')} are formatted correctly.</li>
                    <li>${$b('Email addresses')} are formatted correctly with no spaces or commas.</li>
                    <li>${$b('Phone numbers')} are formatted correctly and contain only 10 numbers.</li>
                    <li>Fields including ${$b('dependants age')} only include numbers.</li>
                </ul>
            </div>
            <div class="mb-0 mt-3" style="font-size: 12px; text-align: left;">
                <!--<div style="font-weight: bold;">Support</div>-->
                <div>
                    If you have checked the application for these common issues including the examples above,
                    contact ${$b('Fintelligence Support')} who can help you
                    in how to enter the data correctly into the application for a better API experience and
                    to prevent a loss of data.
                </div>
            </div>
        </div>`

        // Show error modal
        swal.fire({
            title: 'Warning',
            html,
            type: 'error',
            showCloseButton: true,
            showCancelButton: true
        })
    }

    axiosError(error) {
        const allowAllErrors = window.devMode === true ? true : this.allowAllErrors

        // Any status codes that falls outside the range of 2xx cause this function to trigger
        const data = error.response.data
        const statusCode = error.response.status

        // Exclude certain error codes
        const exclusionCodes = [404]
        if (allowAllErrors === false && exclusionCodes.includes(statusCode)) return false

        // Do something with response error
        const html = `
        <h3 class="mb-3">Unfortunately there was an error</h3>
        <h4>${error.message}</h4>
        <div class="my-2" style="
            font-family: monospace; text-align: left; padding: 15px;
            line-height: 2;">

            <!--<div class="mt-3" style="font-size: 12px;">
                ${data.message}
            </div>-->
            <!--<div style="color: red; font-size: 14px; font-weight: bold;">
                ${data.exception}
            </div>-->

            <div class="mb-1" style="color: red;">
                <div style="font-weight: bold;">Exception</div>
                <div style="font-size: 10px;">${data.exception}</div>
            </div>
            <div class="mb-1" style="">
                <div style="font-weight: bold;">Message</div>
                <div style="font-size: 10px;">${data.message || 'NA'}</div>
            </div>
            <div class="mb-1">
                <div style="font-weight: bold;">File</div>
                <div style="font-size: 10px;">${data.file}:${data.line}</div>
            </div>
            <div class="mb-1">
                <div style="font-weight: bold;">URL</div>
                <div style="font-size: 10px;">${location.href}</div>
            </div>-->

            <!--<div class="mb-0">
                <div style="font-weight: bold;">Did You Know?</div>
                <div style="font-size: 10px;">
                    You can open the Backup Viewer by pressing: <br />
                    <div class="ml-3">Alt + A (or Option + A on Mac)</div>
                </div>
            </div>-->
            <div class="mb-0 mt-3">
                <div style="font-weight: bold;">Support</div>
                <div style="font-size: 10px;">
                    Contact <span style="font-weight: bold;">Fintelligence</span> for further help with this error.
                </div>
            </div>
        </div>`

        // Show error modal
        swal.fire({
            // title: 'Request Error',
            // title: 'Unfortunately there was an error',
            html,
            type: 'error',
            showCloseButton: true,
            showCancelButton: true
        })
        return Promise.reject(error)
    }
}
